<header
  class="dialog-header"
  cdkDragHandle
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragConstrainPosition]="constrainPosition"
  (cdkDragStarted)="onDragStarted($event)"
  [ngStyle]="customStyles()"
  >
  <ng-content></ng-content>
  @if (!hideCloseIcon()) {
    <button
      (click)="close()"
      tabindex="0"
      (keyup.enter)="close()"
      class="button close-btn"
      data-button-variant="header-icon"
      aria-label="Close Dialog"
      >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="close-icon" aria-hidden="true">
        <path d="M 19.975 -0.05 L 12.01 10.029 L 19.944 20 L 16.149 20 L 9.971 12.223 L 3.794 20 L 0 20 L 8.059 9.84 L 0.22 -0.05 L 4.014 -0.05 L 10.097 7.618 L 16.181 -0.05 L 19.975 -0.05 Z" />
      </svg>
    </button>
  }
</header>
